export const filters = {
  namespaced: true,
  state: {
    startDate: undefined,
    endDate: undefined,
  },
  actions: {
    update({ commit }, filter) {
      commit("setFilter", filter);
    },
  },
  mutations: {
    setFilter(state, filter) {
      state.startDate = filter.startDate;
      state.endDate = filter.endDate;
    },
  },
};
